export function timezoneFormatter(timezone) {
	switch (timezone) {
		case 'America/New_York':
			return 'Eastern Time';
		case 'America/Chicago':
			return 'Central Time';
		case 'America/Denver':
			return 'Mountain Time';
		case 'America/Los_Angeles':
			return 'Pacific Time';
		case 'America/Phoenix':
			return 'Arizona Time';
		case 'America/Anchorage':
			return 'Alaska Time';
		case 'Pacific/Honolulu':
			return 'Hawaii Time';
		case 'America/Adak':
			return 'Hawaii-Aleutian Time';
		case 'Pacific/Midway':
			return 'Samoa Time';
		case 'Pacific/Pago_Pago':
			return 'Samoa Time';
		case 'Pacific/Guam':
			return 'Chamorro Time';
		case 'Pacific/Saipan':
			return 'Chamorro Time';
		case 'Pacific/Tarawa':
			return 'Gilbert Time';
		case 'America/Boise':
			return 'Mountain Time (Boise)';
		case 'America/Indiana/Indianapolis':
			return 'Eastern Time (Indiana)';
		case 'America/Indiana/Knox':
			return 'Central Time (Indiana)';
		case 'America/Indiana/Marengo':
			return 'Eastern Time (Indiana)';
		case 'America/Indiana/Petersburg':
			return 'Eastern Time (Indiana)';
		case 'America/Indiana/Tell_City':
			return 'Central Time (Indiana)';
		case 'America/Indiana/Vevay':
			return 'Eastern Time (Indiana)';
		case 'America/Indiana/Vincennes':
			return 'Eastern Time (Indiana)';
		case 'America/Indiana/Winamac':
			return 'Eastern Time (Indiana)';
		case 'America/Kentucky/Louisville':
			return 'Eastern Time (Kentucky)';
		case 'America/Kentucky/Monticello':
			return 'Eastern Time (Kentucky)';
		case 'America/Menominee':
			return 'Central Time (Menominee)';
		case 'America/Nome':
			return 'Alaska Time (Nome)';
		case 'America/North_Dakota/Beulah':
			return 'Central Time (North Dakota)';
		case 'America/North_Dakota/Center':
			return 'Central Time (North Dakota)';
		case 'America/North_Dakota/New_Salem':
			return 'Central Time (North Dakota)';
		case 'Pacific/Fakaofo':
			return 'Tokelau Time';
		case 'America/Sitka':
			return 'Alaska Time (Sitka)';
		case 'America/Yakutat':
			return 'Alaska Time (Yakutat)';
		case 'America/Juneau':
			return 'Alaska Time (Juneau)';
		case 'America/Metlakatla':
			return 'Alaska Time (Metlakatla)';
		case 'America/Santa_Isabel':
			return 'Pacific Time (Santa Isabel)';
		case 'America/Tijuana':
			return 'Pacific Time (Tijuana)';
		case 'America/Detroit':
			return 'Eastern Time (Detroit)';
		default:
			return timezone;
	}
}

export const routeTitles = {
  '/': 'Federal Tax Calculator',
  '/federal-tax': 'Federal Tax Calculator',
  '/business-tax': 'Uncle Kam Small Business Tax Calculator',
  '/crypto-tax': 'Cryptocurrency Tax Calculator',
  '/capital-gains': 'Capital Gains Tax Calculator',
  '/tax-brackets': 'Tax Bracket Calculator',
  '/bonus-tax': 'Bonus Tax Calculator',
  '/retirement-savings': 'Retirement Savings Calculator',
  '/mortgage-deduction': 'Mortgage Interest Deduction Calculator',
  '/self-employment-tax': 'Self-Employment Tax Calculator',
  '/multi-step-lead-generation': 'Multi-step Lead Generation',
  '/simple-lead-form': 'Simple Lead Generation Form',
  '/book-appointment': 'Book Appointment Form',
  '/one-step-order-form': 'One-Step Order Form',
  '/two-step-order-form': 'Two-Steps Order Form',
  '/course-order-form': 'Course Order Form',
  '/upsell-order-form': 'Upsell Order Form',
  '/lead-generation-form': 'Lead Generation Form',
  '/questionnaire-form': 'Questionnaire Form',
  '/tax-pros': 'Tax Professionals',
  '/redirect-button': 'Redirect Button',
  '/book-appointment-v3': 'Book Appointment Form V3',
  '/pro-card': 'Pro Card',
};


export const categories = {
    'Calculators': [
        { path: '/federal-tax', title: 'Federal Tax Calculator' },
        { path: '/business-tax', title: 'Uncle Kam Small Business Tax Calculator' },
        { path: '/crypto-tax', title: 'Cryptocurrency Tax Calculator' },
        { path: '/capital-gains', title: 'Capital Gains Tax Calculator' },
        { path: '/tax-brackets', title: 'Tax Bracket Calculator' },
        { path: '/bonus-tax', title: 'Bonus Tax Calculator' },
        { path: '/retirement-savings', title: 'Retirement Savings Calculator' },
        { path: '/mortgage-deduction', title: 'Mortgage Interest Deduction Calculator' },
        { path: '/self-employment-tax', title: 'Self-Employment Tax Calculator' },
        { path: '/home-office', title: 'Home Office Calculator' },
    ],
    'Forms': [
        { path: '/course-order-form', title: '🎓 Course Order Form (NEW)' },
        { path: '/multi-step-lead-generation', title: 'Multi-step Lead Generation' },
        { path: '/simple-lead-form', title: 'Simple Lead Generation Form' },
        { path: '/book-appointment', title: 'Book Appointment Form' },
        { path: '/book-appointment-v2', title: 'Book Appointment Form V2' },
        { path: '/book-appointment-v3', title: 'Book Appointment Form V3' },
        { path: '/one-step-order-form', title: 'One-Step Order Form' },
        { path: '/two-step-order-form', title: 'Two-Steps Order Form' },
        { path: '/upsell-order-form', title: 'Upsell Order Form' },
        { path: '/lead-generation-form', title: 'Lead Generation Form' },
        { path: '/questionnaire-form', title: 'Questionnaire Form' },
        { path: '/tax-pros', title: 'Tax Professionals' },
        { path: '/redirect-button', title: 'Redirect Button' },
        { path: '/pro-card', title: 'Pro Card' },
    ]
};